import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  CheckAllRoles,
  CheckRoleForClient,
  CheckAllRights,
  CheckRightsForClient,
  CheckCrmUserManagementRoleForClient,
} from "../../Helpers/PermissionsChecks";
import { selectClientValue } from "../../State/Slices/SelectedClientSlice";
import { selectUserPermissionsValue } from "../../State/Slices/UserPermissionsSlice";
import { RouteTypes } from "../../Enums/RouteTypes";

function checkRouteAccess(
  rolesObject,
  currentClient,
  routeType,
  requiredPermissions
) {
  switch (routeType) {
    case RouteTypes.Unprotected:
      return true;
    case RouteTypes.RoleProtected:
      return CheckAllRoles(rolesObject, requiredPermissions);
    case RouteTypes.ClientRoleProtected:
      return CheckRoleForClient(
        rolesObject,
        currentClient,
        requiredPermissions
      );
    case RouteTypes.RightProtected:
      return CheckAllRights(rolesObject, requiredPermissions);
    case RouteTypes.ClientRightProtected:
      return CheckRightsForClient(
        rolesObject,
        currentClient,
        requiredPermissions
      );
    case RouteTypes.ClientCrmRightsProtected:
      return (
        CheckCrmUserManagementRoleForClient(rolesObject, currentClient) ||
        CheckRightsForClient(rolesObject, currentClient, requiredPermissions)
      );
    default:
      return false;
  }
}

export default function ProtectedRoute(props) {
  const Component = props.component;
  const requiredPermissions = props.requiredPermissions;
  const routeType = props.routeType;
  const rolesObject = useSelector(selectUserPermissionsValue);
  const selectedClient = useSelector(selectClientValue);
  const hasRoutePermissions = checkRouteAccess(
    rolesObject,
    selectedClient.id?.toUpperCase(),
    routeType,
    requiredPermissions
  );
  const componentProps = props.componentProps;

  return hasRoutePermissions ? (
    <Component props={componentProps} />
  ) : (
    <Redirect to={{ pathname: "/" }} />
  );
}
